import { ThemeProvider } from 'styled-components'
import { WidgetThemeProps } from './widget.types'
import * as Styles from './widget.styles'

export const WidgetTheme = ({
  theme,
  tipOrder = 0,
  children,
  tipBackgroundColor,
}: WidgetThemeProps) => {
  const tipPosition = () => 72 + 64 * tipOrder

  return (
    <ThemeProvider theme={theme}>
      <Styles.ThemeContainer>
        <Styles.TipIcon $tipPosition={tipPosition()} $tipBackgroundColor={tipBackgroundColor} />
        <Styles.Container>{children}</Styles.Container>
      </Styles.ThemeContainer>
    </ThemeProvider>
  )
}
